import { render } from "./MobileAboutView.vue?vue&type=template&id=510047e8&scoped=true"
import script from "./MobileAboutView.vue?vue&type=script&lang=js"
export * from "./MobileAboutView.vue?vue&type=script&lang=js"

import "./MobileAboutView.vue?vue&type=style&index=0&id=510047e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510047e8"]])

export default __exports__